"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmissionStatusGraph = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const Colors_1 = require("../../../../../Colors");
const server_1 = require("../../../../../server");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const common_1 = require("../../../../../common");
const SubmissionStyled = styled_components_1.default.div `
	${props => (props.$isMobile ? mobileStyles : props.$isTablet ? tabletStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	border-style: solid;
	border-color: var(--color-silver, #f3f4f8);
	border-width: ${props => (props.$isHome ? '0px' : '0px 1px 0px 0px;')};
	display: flex;
	flex-direction: column;
	gap: ${props => (props.$isHome ? '6px' : '32px')};
	align-items: center;
	justify-content: ${props => (props.$isHome ? 'flex-start' : 'center')};
	flex-shrink: 0;
	position: relative;

	.submission_status_container {
		display: flex;
		flex-direction: column;
		gap: 28px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		width: 100%;
	}

	${props => props.$isHome
    ? (0, styled_components_1.css) `
					.number-people {
						border-radius: 10px;
						border-style: solid;
						border-color: var(--color-grey-c, #e6e8ed);
						border-width: 1px;
						padding: 12px 20px 12px 20px;
						display: flex;
						flex-direction: row;
						gap: 12px;
						align-items: flex-start;
						justify-content: space-around;
						align-self: stretch;
						flex-shrink: 0;
						position: relative;

						.submission-txt-wrap {
							display: flex;
							flex-direction: column;
							gap: 4px;
							align-items: center;
							justify-content: center;
							flex: 1;
							position: relative;
						}

						.submission_status_wrap {
							display: flex;
							flex-direction: row;
							gap: 6px;
							align-items: center;
							justify-content: flex-start;
							flex-shrink: 0;
							position: relative;
						}
					}

					.submission-headline,
					.submission-headline2 {
						text-align: left;
						font-family: 'Noto Sans KR', sans-serif;
						font-size: 14px;
						line-height: 150%;
						letter-spacing: -0.02em;
						font-weight: 400;
						position: relative;
						display: flex;
						align-items: center;
						justify-content: center;
					}

					.submission_status_container {
						gap: 0px;
					}
			  `
    : (0, styled_components_1.css) `
					.number-people {
						background: var(--color-white, #ffffff);
						border-radius: 10px;
						padding: 20px;
						display: flex;
						flex-direction: column;
						gap: 8px;
						align-items: flex-start;
						justify-content: flex-start;
						flex-shrink: 0;
						position: relative;
						box-shadow: var(
							--shadow-bg-box-shadow,
							0px 2px 6px 0px rgba(224, 226, 235, 0.4)
						);
						width: 100%;

						.submission_txt_wrap {
							display: flex;
							flex-direction: row;
							gap: 6px;
							align-items: center;
							justify-content: space-between;
							flex-shrink: 0;
							height: 42px;
							position: relative;
							width: 100%;
						}

					}

					.submission-headline,
					.submission-headline2 {
						text-align: left;
						font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);
						font-size: var(--h4-font-size, 18px);
						line-height: 150%
						letter-spacing: var(--h4-letter-spacing, -0.02em);
						font-weight: var(--h4-font-weight, 700);
						position: relative;
						display: flex;
						align-items: center;
						justify-content: flex-start;
					}

					.submission_status_container {
						gap: 28px;
					}
			  `};
`;
const tabletStyles = (0, styled_components_1.css) `
	border-style: solid;
	border-color: var(--color-silver, #f3f4f8);
	border-width: ${props => (props.$isHome ? '0px' : '0px 1px 0px 0px;')};
	padding: ${props => (props.$isHome ? '6px 12px 6px 12px;' : '0px;')};
	display: flex;
	flex-direction: column;
	gap: ${props => (props.$isHome ? '12px' : '32px')};
	align-items: center;
	justify-content: ${props => (props.$isHome ? 'flex-start' : 'center')};
	flex-shrink: 0;
	position: relative;

	.submission_status_container {
		display: flex;
		flex-direction: ${props => (props.$isHome ? 'column' : 'row')};
		gap: ${props => (props.$isHome ? '14px' : '28px')};
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	.number-people {
		.submission_txt_wrap {
			display: flex;
			flex-direction: row;
			gap: 6px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			height: ${props => (props.$isHome ? '32px' : '42px')};
			position: relative;
		}

		.submission_status_wrap {
			display: flex;
			flex-direction: row;
			gap: 6px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			.divider {
				background: #d9d9d9;
				flex-shrink: 0;
				width: 1px;
				height: 16px;
				position: relative;
			}
		}
	}

	${props => props.$isHome
    ? (0, styled_components_1.css) `
					.number-people {
						border-radius: 10px;
						border-style: solid;
						border-color: var(--color-grey-c, #e6e8ed);
						border-width: 1px;
						padding: 6px 12px 6px 12px;
						display: flex;
						flex-direction: column;
						gap: 0px;
						align-items: center;
						justify-content: flex-start;
						flex-shrink: 0;
						position: relative;
					}

					.submission-headline,
					.submission-headline2 {
						text-align: left;
						font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
						font-size: var(--b4-font-size, 14px);
						line-height: var(--b4-line-height, 28px);
						letter-spacing: var(--b4-letter-spacing, -0.02em);
						font-weight: var(--b4-font-weight, 400);
						position: relative;
						display: flex;
						align-items: center;
						justify-content: flex-start;
					}
			  `
    : (0, styled_components_1.css) `
					.number-people {
						background: var(--color-white, #ffffff);
						border-radius: 10px;
						padding: 20px;
						display: flex;
						flex-direction: column;
						gap: 8px;
						align-items: flex-start;
						justify-content: flex-start;
						flex-shrink: 0;
						position: relative;
						box-shadow: var(
							--shadow-bg-box-shadow,
							0px 2px 6px 0px rgba(224, 226, 235, 0.4)
						);
						min-width: 218px;
						.submission_txt_wrap {
							width: 100%;
						}
					}

					.submission-headline,
					.submission-headline2 {
						text-align: left;
						font-family: 'Noto Sans KR', sans-serif;
						font-size: 18px;
						line-height: 150%;
						letter-spacing: -0.02em;
						font-weight: 700;
						position: relative;
						display: flex;
						align-items: center;
						flex: 1;
					}

					.submission-headline {
						justify-content: flex-start;
						min-width: 90px;
					}

					.submission-headline2 {
						justify-content: flex-end;
					}
			  `};
`;
const desktopStyles = (0, styled_components_1.css) `
	border-style: solid;
	border-color: var(--color-silver, #f3f4f8);
	border-width: ${props => (props.$isHome ? '0px' : '0px 1px 0px 0px;')};
	padding: ${props => (props.$isHome ? '6px 12px 6px 12px;' : ' 0px 20px 0px 0px;')};
	display: flex;
	flex-direction: column;
	gap: ${props => (props.$isHome ? '14px' : '32px')};
	align-items: center;
	justify-content: ${props => (props.$isHome ? 'flex-start' : 'center')};
	flex-shrink: 0;
	position: relative;

	.submission_status_container {
		display: flex;
		flex-direction: ${props => (props.$isHome ? 'column' : 'row')};
		gap: ${props => (props.$isHome ? '12px' : '28px')};
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}

	${props => props.$isHome
    ? (0, styled_components_1.css) `
					.number-people {
						border-radius: 10px;
						border-style: solid;
						border-color: var(--color-grey-c, #e6e8ed);
						border-width: 1px;
						padding: 6px 12px 6px 12px;
						display: flex;
						flex-direction: column;
						gap: 0px;
						align-items: center;
						justify-content: flex-start;
						flex-shrink: 0;
						position: relative;
					}

					.submission-headline,
					.submission-headline2 {
						text-align: left;
						font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
						font-size: var(--b4-font-size, 14px);
						line-height: var(--b4-line-height, 28px);
						letter-spacing: var(--b4-letter-spacing, -0.02em);
						font-weight: var(--b4-font-weight, 400);
						position: relative;
						display: flex;
						align-items: center;
						justify-content: flex-start;
					}
			  `
    : (0, styled_components_1.css) `
					.number-people {
						background: var(--color-white, #ffffff);
						border-radius: 10px;
						padding: 20px;
						display: flex;
						flex-direction: column;
						gap: 8px;
						align-items: flex-start;
						justify-content: flex-start;
						flex-shrink: 0;
						position: relative;
						box-shadow: var(
							--shadow-bg-box-shadow,
							0px 2px 6px 0px rgba(224, 226, 235, 0.4)
						);
					}

					.submission-headline,
					.submission-headline2 {
						text-align: left;
						font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);
						font-size: var(--h4-font-size, 20px);
						line-height: var(--h4-line-height, 32px);
						letter-spacing: var(--h4-letter-spacing, -0.02em);
						font-weight: var(--h4-font-weight, 700);
						position: relative;
						display: flex;
						align-items: center;
						justify-content: flex-start;
					}
			  `};

	.number-people {
		.submission_txt_wrap {
			display: flex;
			flex-direction: row;
			gap: 6px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			height: ${props => (props.$isHome ? '32px' : '42px')};
			position: relative;
		}

		.submission_status_wrap {
			display: flex;
			flex-direction: row;
			gap: 6px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			.divider {
				background: #d9d9d9;
				flex-shrink: 0;
				width: 1px;
				height: 16px;
				position: relative;
			}
		}
	}
`;
exports.SubmissionStatusGraph = react_1.default.memo(({ isHome = false, test_id, subject_item, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const [submitted, setSubmitted] = react_1.default.useState(0);
    const [notSubmitted, setNotSubmitted] = react_1.default.useState(0);
    const { data, refetch } = (0, server_1.useSubmitStatus)({
        id: test_id,
        subject_item,
    });
    (0, react_1.useEffect)(() => {
        test_id && refetch();
    }, [test_id, subject_item]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { submitted, not_submitted } = data;
            setSubmitted(submitted);
            setNotSubmitted(not_submitted);
        }
    }, [data]);
    const renderPerson = (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "submission_txt_wrap" },
            react_1.default.createElement("p", { className: "submission-headline", style: { color: Colors_1.Colors.light_tur } }, t(`assignment.${isHome ? 'submitted' : 'submitPerson'}`)),
            react_1.default.createElement("p", { className: "submission-headline2" }, t('assignment.person', { count: submitted }))),
        isHome && !isMobile && react_1.default.createElement("div", { className: "divider" }),
        react_1.default.createElement("div", { className: "submission_txt_wrap" },
            react_1.default.createElement("p", { className: "submission-headline", style: { color: '#F46790' } }, t(`assignment.${isHome ? 'notSubmitted' : 'noSubmitPerson'}`)),
            react_1.default.createElement("p", { className: "submission-headline2" }, t('assignment.person', { count: notSubmitted }))))), [submitted, notSubmitted]);
    return (react_1.default.createElement(SubmissionStyled, { "$isHome": isHome, "$isMobile": isMobile, "$isTablet": isTablet, className: "submission_status_graph" },
        react_1.default.createElement("div", { className: "dst001_detail_title" },
            t('assignment.submitStatus'),
            " "),
        react_1.default.createElement("div", { className: "submission_status_container" },
            react_1.default.createElement(common_1.DoughnutChart, { size: isHome ? 160 : 200, percentage: Math.round((submitted / (submitted + notSubmitted)) * 100) }),
            react_1.default.createElement("div", { className: "number-people" },
                react_1.default.createElement("div", { className: "submission_txt_wrap" },
                    react_1.default.createElement("p", { className: "submission-headline" }, "\uCD1D \uC778\uC6D0"),
                    react_1.default.createElement("p", { className: "submission-headline2", style: { color: Colors_1.Colors.p_ture } }, t('assignment.person', { count: submitted + notSubmitted }))),
                isHome && !isMobile ? (react_1.default.createElement("div", { className: "submission_status_wrap" }, renderPerson)) : (renderPerson)))));
});
